import React from 'react';
import {useAxios} from '../hooks';

const usePessoas = () => {

    const {getApiEmitirNotas} = useAxios();

    const listaPessoas = async (tipo = "CLIENTE") => {
        const api = await getApiEmitirNotas();
        const result = await api.get('/pessoas/filtro?tipoPessoa='+tipo+'&termo=')
        return result.data;
    }
    
    return {listaPessoas};
}

export {usePessoas};